module.exports = ":host .content {\n  opacity: 0;\n  transition: all 1.5s ease-in-out;\n  -webkit-transition: all 1.5s ease-in-out;\n  -moz-transition: all 1.5s ease-in-out;\n  -o-transition: all 1.5s ease-in-out; }\n  :host .content footer {\n    font-size: 0.75rem;\n    margin-top: 15rem; }\n  @media (max-width: 1024px) {\n      :host .content footer {\n        margin-top: 2rem; } }\n  :host .content.transition-ready {\n    opacity: 1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/home/home.component.scss
// module id = ./src/app/views/home/home.component.scss
// module chunks = main